import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/auth/AuthProvider";
import { ThemeProvider } from "@/theme/ThemeContext";
import LoginPage from "@/auth/LoginPage";
import ProtectedRoute from "@/auth/ProtectedRoute";
import AppShell from "@/layout/AppShell";
import RemoteApp from "@/components/RemoteApp";
import NotFound from "@/pages/NotFound";
import { APP_REGISTRY } from "@/registry/appRegistry";

export default function App() {
  const firstApp = APP_REGISTRY[0];
  const defaultPath = firstApp.defaultRoute
    ? `${firstApp.basePath}/${firstApp.defaultRoute}`
    : firstApp.basePath;

  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                {/* Default: redirect to first registered app */}
                <Route index element={<Navigate to={defaultPath} replace />} />

                {/* Dynamic routes for each federated child app */}
                {APP_REGISTRY.map((app) => (
                  <Route
                    key={app.id}
                    path={`${app.basePath.slice(1)}/*`}
                    element={<RemoteApp appConfig={app} />}
                  />
                ))}

                <Route path="*" element={<NotFound />} />
              </Route>
            </Route>
          </Routes>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
